export default "__VITE_ASSET__ZHTCh1zR__"